import * as React from 'react';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';

// Utils
import { FormatDate } from '../../../../utils/formatDate';
import { useTranslation } from 'react-i18next'
import { InputContainer, InputText } from '../SearchBarWorkflow/styles';
import moment from 'moment';

export const SearchBar = ({
    setFilteredRequest,
    rows,
    filterText,
    filterKeys,
    initialValue = ''
}) => {

    const { t } = useTranslation();
    const [search, setSearch] = React.useState(initialValue)
    const {format} = new FormatDate();

    function handleSearch(e) {
        setSearch(e)
        filterSearch(e)
    }
    
    const filterSearch = (data) => {
        let searchResults = []
        rows.filter(e => {
            filterKeys.map(obj => {
                let value = e[obj]

                // Check if the element to search is inside an object
                if (obj.indexOf('.') > -1) {
                    value = eval(obj)
                }
                // Transforms the date to search in long format
                if ((obj === 'updatedAt' || obj === 'createdAt' || obj === 'lastUpdate') && e[obj]) {
                    value = moment(e[obj]).format('DD/MM/YYYY HH:mm');
                }
                
                if (toLower(value, data)) {
                    if (!searchResults.some((el) => el.id === e.id)) searchResults.push(e)
                    return e
                }
            })
        })

        setFilteredRequest(searchResults)
    }
	
	const toLower = (value, data) => {
        return value?.toString().toLowerCase().includes(data?.toString()?.toLowerCase())
    }

    React.useEffect(() => {
        setFilteredRequest(rows);
        handleSearch(search);
    }, [rows])

    React.useEffect(() => {
        if (initialValue) {
            handleSearch(initialValue);
        }
    }, [initialValue])

    return (
        <InputContainer
            component="form"
            elevation={0}
        >
            <IconButton type="button" sx={{ p: '5px' }} aria-label="search" disabled>
                <SearchIcon />
            </IconButton>
            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            <InputText
                type='text'
                name='search'
                value={search}
                onChange={e => handleSearch(e.target.value)}
                autoComplete='off'
                placeholder={filterText || t('common.searchBars.workflows')}
                inputProps={{ 'aria-label': 'search google maps' }}
            />
        </InputContainer>
    );
}